module.exports = __webpack_public_path__ + "static/img/undraw_having_fun_iais.40f540f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/undraw_having_fun_iais.svg
// module id = LcWV
// module chunks = 1